module.exports = __webpack_public_path__ + "static/img/Partners4.b8ef897.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Partners4.png
// module id = r3+D
// module chunks = 10